// theme.js
import { extendTheme } from '@mui/joy/styles';

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          solidBg: '#00A884',
          solidHoverBg: '#009973',
          solidActiveBg: '#008262',
        },
        success: {
          solidBg: '#007E33',
          solidHoverBg: '#00682A',
          solidActiveBg: '#005122',
        },
        background: {
          body: '#f8f9fa',
          surface: '#ffffff',
          level1: '#f5f5f5',
          level2: '#e9ecef',
          level3: '#dee2e6',
        },
        text: {
          primary: '#212529',
          secondary: '#6c757d',
        },
        neutral: {
          plainHoverBg: '#f1f3f5',
          outlinedHoverBorder: '#ced4da',
        },
      },
    },
  },
  fontFamily: {
    display: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    'title-lg': {
      fontSize: '1.125rem',
      fontWeight: 600,
    },
    'title-md': {
      fontSize: '1rem',
      fontWeight: 600,
    },
    'body-lg': {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    'body-md': {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    'body-sm': {
      fontSize: '0.8125rem',
      lineHeight: 1.5,
    },
  },
  components: {
    JoyButton: {
      defaultProps: {
        size: 'sm',
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: '6px',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0px)',
          },
        },
      },
    },
    JoyInput: {
      defaultProps: {
        size: 'sm',
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          borderRadius: '6px',
          transition: 'all 0.2s ease',
          '&:focus-within': {
            boxShadow: '0 0 0 2px rgba(0, 168, 132, 0.25)',
          },
        },
      },
    },
    JoySelect: {
      defaultProps: {
        size: 'sm',
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          borderRadius: '6px',
        },
      },
    },
    JoyTable: {
      defaultProps: {
        size: 'sm',
        hoverRow: true,
        borderAxis: 'bothBetween',
      },
      styleOverrides: {
        root: {
          borderRadius: '8px',
          overflow: 'hidden',
        },
      },
    },
    JoyCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0, 168, 132, 0.1)',
          },
        },
      },
    },
    JoyChip: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;